import { Box, Paper, Table as MUITable, TableContainer, TablePagination, Typography, TableBody } from '@mui/material';
import React from 'react';

interface TableProps {
  page: number;
  rowsPerPage: number;
  rowsNumber: number;
  handleChangePage(event: unknown, newPage: number): void;
  handleChangeRowsPerPage(event: React.ChangeEvent<HTMLInputElement>): void;
  paginationLabel?: string;
  toolbar?: React.ReactNode;
  head?: React.ReactNode;
  children?: React.ReactNode;
  rowsPerPageOptions?: number[];
}

function Table(props: TableProps) {
  const defaultRowsPerPageOptions = [10, 25, 50, 100];
  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 0.25
      }}>
        <Typography variant="body2" sx={{ pl: 1, fontSize: '0.75rem' }}>
          {props.paginationLabel || ''}
        </Typography>
        <TablePagination
          rowsPerPageOptions={props.rowsPerPageOptions || defaultRowsPerPageOptions}
          component="div"
          count={props.rowsNumber}
          rowsPerPage={props.rowsPerPage}
          page={props.page}
          onPageChange={props.handleChangePage}
          onRowsPerPageChange={props.handleChangeRowsPerPage}
          labelRowsPerPage="Rows:"
          sx={{
            borderBottom: 'none',
            minHeight: '32px',
            '.MuiTablePagination-toolbar': {
              minHeight: '32px',
              pl: 0.5,
              pr: 0.5
            },
            '.MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows': {
              margin: 0,
              fontSize: '0.75rem'
            },
            '.MuiTablePagination-select': {
              marginLeft: 0.5,
              marginRight: 0.5
            }
          }}
        />
      </Box>
      <Paper sx={{ width: '100%', mb: 0.5 }}>
        {props.toolbar}
        <TableContainer sx={{ maxHeight: 'calc(100vh - 180px)', overflow: 'auto' }}>
          <MUITable
            stickyHeader
            sx={{
              minWidth: 750,
              tableLayout: 'auto',
              '.MuiTableCell-root': {
                whiteSpace: 'nowrap',
                overflow: 'visible'
              }
            }}
            aria-labelledby="tableTitle"
            size='small'
          >
            {props.head}
            <TableBody>
              {props.children}
            </TableBody>
          </MUITable>
        </TableContainer>
      </Paper>
    </Box>
  );
}

export default Table;